export type UserType = 'STUDENT' | 'TEACHER' | 'ORGANIZATION';
